import { TriState } from "./Enums";

export class SiteSearchParameters {
    searchText: string = "";
    id: number = 0;
    regionID: number = 0;
    supplierID: number = 0;
    buyerID: number = 0;
    isDeleted: TriState = TriState.UseDefault;
}